export default "__VITE_ASSET__BLUmAGu2__"